import React, { useRef } from 'react';

function ImageUpload() {
  const fileInputRef = useRef(null);

  const handleButtonClick = () => {
    fileInputRef.current.click(); // Trigger the click event of the hidden input
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile && selectedFile.type.startsWith('image/')) {
      // Handle the selected image file here
      console.log('Selected image:', selectedFile);
      // You can also create a URL for preview:
      const imageUrl = URL.createObjectURL(selectedFile);
      console.log('Image URL:', imageUrl);
      // Update state to display the image preview, etc.
    } else {
      console.log('Please select an image file.');
    }
  };

  return (
    <div>
      <input
        type="file"
        accept="image/*" // Restrict to image files
        ref={fileInputRef}
        onChange={handleFileChange}
        style={{ display: 'none' }} // Hide the input element
      />
      <button onClick={handleButtonClick}>Upload Image</button>
    </div>
  );
}

export default ImageUpload;